import React, { Dispatch, SetStateAction, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import axios from 'axios';
import App from './App';
import '@styles/styles.css';

import AlertModal from './components/modal/AlertModal';

const onError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    setGlobalNotification(`Error: ${error.response?.data?.message || 'An unexpected error occurred.'}`);
  }
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError
  })
});

let setGlobalNotification: Dispatch<SetStateAction<string | null>>;

const GlobalNotificationProvider = () => {
  const [notification, setNotification] = useState<string | null>(null);

  setGlobalNotification = setNotification;

  const handleCloseNotification = () => {
    setNotification(null);
  };

  return (
    <>
      {notification && (
        <AlertModal isOpen={true} closeBtn={{ onClose: handleCloseNotification, buttonName: 'Close' }}>
          {notification}
        </AlertModal>
      )}
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
        <GlobalNotificationProvider />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
